import React from 'react';
import BrandSlider1 from '../../components/slider/BrandSlider1'
const Brand = ( ) => {
    
    return (
        <>
            {/*Brand One Start*/}
            <section className="brand-one">
              <div className="container">
                <p className="text-2xl font-bold brand-one__text count-box">
                  Exploring the Tools That Make the Magic Happen
                </p>
                <BrandSlider1/>
              </div>
            </section>
            {/*Brand One End*/}
        </>
    );
}
export default Brand;